import React from 'react';
import { FaMapPin, FaChartBar, FaFileAlt, FaLock, FaQrcode, FaHandHoldingUsd } from 'react-icons/fa';

import icon1 from './assets/icons/f_icon1.svg';
import icon2 from './assets/icons/f_icon2.svg';
import icon3 from './assets/icons/f_icon3.svg';
import icon4 from './assets/icons/f_icon4.svg';
import icon5 from './assets/icons/f_icon5.svg';
import icon6 from './assets/icons/f_icon6.svg';


const featuresData = [
    {
        mainIcon: icon1,
        titleIcon: FaMapPin,
        titleIconColor: 'text-red-500',
        title: 'Property Amenity Tool',
        description:
            'Become an instant expert on any neighborhood. Instantly pull schools, shopping, tech hubs & more — just by typing an address.',
    },
    {
        mainIcon: icon2,
        titleIcon: FaChartBar,
        titleIconColor: 'text-green-500',
        title: 'CMA Snapshot Generator',
        description:
            'Build clean, accurate comps using public data — no MLS access needed.',
    },
    {
        mainIcon: icon3,
        titleIcon: FaFileAlt,
        titleIconColor: 'text-gray-500',
        title: 'Branded Flyer Builder',
        description:
            'Auto-generate sleek, professional flyers and send them on the go — right from your phone.',
    },
    {
        mainIcon: icon4,
        titleIcon: FaLock,
        titleIconColor: 'text-yellow-500',
        title: 'Agent-Only Access',
        description:
            'License-verified login. No consumers. No fluff. Just serious tools for serious agents.',
    },
    {
        mainIcon: icon5,
        titleIcon: FaQrcode,
        titleIconColor: 'text-gray-800',
        title: 'Shareable Digital Agent Card',
        description:
            'Create your own QR code with photo, contact info, website, and social links — all in one tap.',
    },
    {
        mainIcon: icon6,
        titleIcon: FaHandHoldingUsd,
        titleIconColor: 'text-yellow-600',
        title: '30% Lifetime Referral Income',
        description:
            'Refer other agents. Earn 30% of their monthly subscription — for life.',
    },
];


const FeatureCard = ({ mainIcon, titleIcon: TitleIcon, titleIconColor, title, description }) => (
    <div className="bg-white rounded-2xl p-6 shadow-lg flex flex-col items-start h-full">

        <div className="w-14 h-14 rounded-xl  flex items-center justify-center mb-6">
            
             <img src={mainIcon} alt="" className="w-12 h-12" />
        </div>


        <div className="flex items-center mb-2">
            <TitleIcon className={`mr-2 ${titleIconColor}`} />
            <h3 className=" font-semibold text-gray-800">{title}</h3>
        </div>


        <p className="text-gray-600 text-sm" style={{fontFamily: 'Inter, "Helvetica Neue", Helvetica, Arial, sans-serif' }}>{description}</p>
    </div>
);


const FeaturesSection = () => {
    return (
        <section id="featuresSection" className="relative bg-white pt-20 pb-24 overflow-hidden">


            <div
                className="bg-[#F8F8F8] absolute inset-x-0 top-0 h-full rounded-none lg:ml-[2.6rem] lg:rounded-tl-[1.9rem] lg:rounded-bl-[1.9rem]"
                aria-hidden="true"
            ></div>


            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">


                <div className="text-left">



                    <h4 className="block lg:hidden font-bold text-xl mb-2">
                        Phase 1 - Features
                    </h4>


                    <p className="block lg:hidden text-base text-gray-700 mb-6 max-w-xl">
                        Take a look at our wide range of featured properties. We provide the best and quality housing at very affordable prices for you and your family.
                    </p>

                    <h2 className=" hidden lg:block text-4xl lg:text-5xl font-bold text-gray-800 tracking-tight
      [@media(min-width:1015px)]:ml-[2.4rem]">
                        Finally, an App That
                        <br />
                        Moves as Fast as You Do
                    </h2>
                </div>


                <div className="mt-16 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
    [@media(min-width:1015px)]:ml-[2.4rem]">
                    {featuresData.map((feature, index) => (
                        <FeatureCard key={index} {...feature} />
                    ))}
                </div>
            </div>


        </section>
    );
};

export default FeaturesSection;